import template from './subscriptionCancelModal.html';
import controller from './subscriptionCancelModalCtrl';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    familyId: '<',
    subscriptionData: '<',
  },
};
